import { ConfigValueType } from '../../enums/ConfigValueType.enum';
import { ConfigEditorDetailVariant } from '../../../domain/config';
import { ChangeDetectionStrategy, Component, forwardRef, Input, OnChanges, OnDestroy } from '@angular/core';
import { UntypedFormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { createFormArray, createFormControl, TypedChanges, TypedFormArray, TypedFormControl, ValueAccessorBase } from 'osn-shared';
import { Subscription } from 'rxjs';
import { ConfigEditorListItemViewModelValue } from '../../../config-editor-screen/components/config-editor-screen/config-editor-screen.view-model';
import { getDefaultValueByConfigType } from '../../functions/config-editor-detail.helper';

@Component({
  selector: 'osn-cxb-config-value-editor',
  templateUrl: './config-value-editor.component.html',
  styleUrls: ['./config-value-editor.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ConfigValueEditorComponent), multi: true }],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfigValueEditorComponent extends ValueAccessorBase<ConfigEditorListItemViewModelValue> implements OnChanges, OnDestroy {
  public readonly ConfigValueType = ConfigValueType;
  private subscription: Subscription;

  @Input() public type: ConfigValueType = ConfigValueType.String;
  @Input() public variant: ConfigEditorDetailVariant = ConfigEditorDetailVariant.New;
  @Input() public isListView = false;
  @Input() public editValueAccess = false;
  @Input() public configFunctionsAccess = false;

  public readonly formControl: TypedFormControl<string | number | boolean> = createFormControl(getDefaultValueByConfigType(this.type));

  public arrayControl: TypedFormArray<string | number> = createFormArray([]);

  public ConfigEditorDetailVariant = ConfigEditorDetailVariant;

  constructor() {
    super();
  }

  public ngOnChanges(changes: TypedChanges<Pick<ConfigValueEditorComponent, 'type' | 'isListView'>>): void {
    if ((changes.type || changes.isListView) && this.type) {
      this.handleChanges();
    }
  }

  public ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  public writeValue(value: ConfigEditorListItemViewModelValue) {
    super.writeValue(value);
    if (this.isListView) {
      this.arrayControl.clear({ emitEvent: false });
      if (value instanceof Array) {
        value.forEach((it) => this.arrayControl.push(createFormControl(it)));
      }
      this.arrayControl.setValue(value ?? [], { emitEvent: false });
    } else {
      this.formControl.setValue(value, { emitEvent: false });
    }
  }

  public addElement() {
    this.arrayControl.push(createFormControl(getDefaultValueByConfigType(this.type) as string | number));
    // @ts-ignore
    this.value = this.arrayControl.value;
  }

  public removeElement(control: UntypedFormControl) {
    this.arrayControl.removeAt(this.arrayControl.controls.indexOf(control), { emitEvent: false });
    // @ts-ignore
    this.value = this.arrayControl.value;
  }

  private handleChanges() {
    if (this.isListView) {
      this.arrayControl.clear();
      this.value = [];
      this.subscription?.unsubscribe();
      this.subscription = this.arrayControl.valueChanges.subscribe((value) => (this.value = value as string[] | number[]));
    } else {
      const defaultValue = getDefaultValueByConfigType(this.type);
      this.formControl.setValue(defaultValue, { emitEvent: false });
      this.value = defaultValue;
      this.subscription?.unsubscribe();
      this.subscription = this.formControl.valueChanges.subscribe((value) => (this.value = value));
    }
  }
}
